import React from "react";
import MarketingLayout, { Seo, Reveal, PageHero, FinalCta } from "@/components/marketing/MarketingLayout";
import { EMPLOYEES } from "@/lib/marketingSite";
import { Check } from "@phosphor-icons/react";

export default function AiTeamPage() {
  return (
    <MarketingLayout>
      <Seo title="Meet the 12 AI Employees — Vozelto" path="/ai-team"
        description="Meet your AI marketing team: Marketing Director, Social Manager, Image Studio, SEO Manager, Advertising Manager and 7 more specialists working together on your brand." />
      <PageHero caps="Your AI team" title={<>Twelve specialists.<br /><span className="brand-text">One coordinated team.</span></>}
        subtitle="Each AI employee has a real job description and real deliverables — and they all share one brand memory, so everything they produce fits together." />

      <section className="max-w-6xl mx-auto px-5 pb-16">
        <div className="grid md:grid-cols-2 gap-5" data-testid="ai-team-detail-grid">
          {EMPLOYEES.map((e, i) => (
            <Reveal key={e.slug}>
              <div data-testid={`ai-team-card-${e.slug}`} className="card-matte p-6 h-full group transition-all duration-300 hover:-translate-y-1 hover:border-[#6B3DFF]/30 border border-transparent">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 rounded-xl bg-[#6B3DFF]/12 flex items-center justify-center shrink-0 transition-all duration-300 group-hover:bg-[#6B3DFF]/25">
                    <e.icon size={24} className="brand-text" weight="duotone" />
                  </div>
                  <div>
                    <h3 className="font-head font-semibold text-lg">{e.name}</h3>
                    <p className="mt-1 text-sm text-[#b5b5b5] leading-relaxed">{e.detail}</p>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-white/8">
                  <div className="label-caps text-[10px] mb-2 text-[#7a7a7a]">Delivers</div>
                  <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
                    {e.delivers.map((d) => (
                      <span key={d} className="flex items-center gap-1.5 text-xs text-[#9a9a9a]">
                        <Check size={12} className="brand-text shrink-0" weight="bold" /> {d}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCta title="Put All Twelve to Work Today" sub="Every plan includes the full AI team. 14-day free trial, cancel anytime." />
    </MarketingLayout>
  );
}
